// extracted by mini-css-extract-plugin
export var chip = "_mb-0";
export var icon = "_mb-1";
export var remove = "_mb-2";
export var removeIcon = "_mb-3";